var templates = require.context('.', true, /\.html$/);
templates.keys().forEach(function (key) {
    templates(key);
});

import FilesystemConfig from './config';
import FilesystemService from "./filesystem.service";
import FileuploadDirective from "./fileupload.directive";
import FilepreviewDirective from "./filepreview.directive";

var MODULE_NAME = 'app.ocom';

try {
    angular.module(MODULE_NAME); // if we can't get it then it must not already exist so create our own module
} catch(err) {
    MODULE_NAME = "ocom.filesystem";
    angular.module(MODULE_NAME, []);
}

angular
    .module(MODULE_NAME)
    .config(FilesystemConfig)
    .factory('fileSystem', FilesystemService)
    .directive('ocomFileUpload', FileuploadDirective)
    .directive('ocomFilePreview', FilepreviewDirective);

export default MODULE_NAME;
